import { Button, GridItem } from "@chakra-ui/react";
import { useMachine } from "@xstate/react";
import React from "react";
import { assign, Machine } from "xstate";
import Section from "../../form/section";
import Card from "../../layout/card";
import { StripeElementsWrapper } from "../../stripe/StripeElementsWrapper";
import StripeForm, { SubmitProps } from "../../stripe/StripeForm";
import { PaymentMethod } from "@stripe/stripe-js";

interface IContext {
  invoiceId?: string;
  customerId?: string;
  errorMessage?: string;
  res?: any;
}

const paymentMachine = Machine<IContext>(
  {
    initial: "editing",
    context: {},
    states: {
      editing: {
        id: "editing",
        on: {
          SUBMIT: {
            actions: [
              assign({
                res: (c, e) => e.res,
              }),
            ],
            target: "processing_payment",
          },
        },
      },
      processing_payment: {
        entry: "CLEAR_ERROR",
        invoke: {
          src: "processPayment",
          onDone: [
            {
              target: "success",
            },
          ],
          onError: [
            {
              actions: ["SET_ERROR", "SET_INVOICE_ID", "SET_CUSTOMER_ID"],
              target: "editing",
            },
          ],
        },
      },
      success: {
        type: "final",
      },
    },
  },
  {
    actions: {
      CLEAR_ERROR: assign({
        errorMessage: (c, e) => undefined,
      }),
      SET_ERROR: assign({
        errorMessage: (c, e) => {
          return e.data.message;
        },
      }),
      SET_INVOICE_ID: assign({
        invoiceId: (c, e) => e?.data?.invoiceId || c.invoiceId,
      }),
      SET_CUSTOMER_ID: assign({
        customerId: (c, e) => e.data.customerId || c.customerId,
      }),
    },
  }
);

export type SignupPaymentRes = SubmitProps<{}>;

const PaymentForm: React.FC<{
  processPayment: (
    method: PaymentMethod,
    invoiceId?: string,
    customerId?: string
  ) => Promise<void>;
  onBack: () => void;
}> = ({ processPayment, onBack }) => {
  const [current, send] = useMachine(paymentMachine, {
    services: {
      processPayment: async (c, e) => {
        const method = await e.res.getPaymentMethod();
        await processPayment(method, c.invoiceId, c.customerId);
      },
    },
  });

  const isProcessing = current.matches("processing_payment");

  return (
    <Card>
      <Section columns={4} title="Payment">
        <GridItem colSpan={4}>
          <StripeElementsWrapper
            stripePublishableKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!}
          >
            <StripeForm
              handleSubmit={(res) =>
                send({
                  type: "SUBMIT",
                  res,
                })
              }
              isProcessing={isProcessing}
              submitButtonText="Make payment"
              errorMessage={current.context.errorMessage}
            ></StripeForm>
          </StripeElementsWrapper>
        </GridItem>
        <Button onClick={() => onBack()}>Back</Button>
      </Section>
    </Card>
  );
};

export default PaymentForm;
